import { render, staticRenderFns } from "./ElFileInput.vue?vue&type=template&id=2c22047e&scoped=true&"
import script from "./ElFileInput.vue?vue&type=script&lang=js&"
export * from "./ElFileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c22047e",
  null
  
)

export default component.exports